import Icon from '@vfz/ui/dist/components/icon/icon';
import { useFeature } from 'context/feature/feature.context';
import { FEATURES } from 'models/features.model';
import React from 'react';
import { ContentUtil } from 'utils/content';

import { content } from './payment-success.content';
import * as S from './payment-success.styles';

const contentUtil = new ContentUtil({ content, componentName: 'PaymentSuccess' });

export const PaymentSuccess = () => {
  const isWeroEnabled = useFeature(FEATURES.IDEAL_WERO_REBRANDING);

  return (
    <S.PageWrapper $isWeroEnabled={isWeroEnabled} data-testid="payment-success">
      <S.Title>
        <Icon name="check" variant="solid" />
        <h1>{contentUtil.translate('title')}</h1>
      </S.Title>
      <S.Link to="/facturen">
        <Icon name="arrowLeft" variant="solid" width={24} height={24} />
        {contentUtil.translate('linkText')}
      </S.Link>
    </S.PageWrapper>
  );
};
